
import { AxiosUtil } from '../utils/axiosUtil';
import { HttpMethod } from '../utils/enums';
import { getMbServerToken } from '../../utils/cookieUtils';


export class PresignedUrlApiHelper {

    static apiUrl = process.env.REACT_APP_REIMBURSEMENT_URL
    static async generatePresignedUrl(request_body) {

        const authToken = getMbServerToken();
  

        const headers = {
            authtoken: authToken
        }

        const response = await AxiosUtil.request(this.apiUrl, HttpMethod.POST, '/files/getSignedUrl', request_body, headers);
        return {
            status: response?.status,
            isSuccess: response?.status >= 200 && response?.status < 300,
            data: response?.data
        };
    }

    static async putFileUsingSignedUrl(signedUrl, file) {
        const response = await AxiosUtil.request(signedUrl, HttpMethod.PUT, signedUrl, file)
        return {
            status: response?.status,
            isSuccess: response?.status >= 200 && response?.status < 300,
            data: response?.data
          };
    }

}